module.exports = __webpack_public_path__ + "img/ecovoucher.5749ae86.svg";